module.exports = __webpack_public_path__ + "static/media/team.c06c616b.svg";